import { render } from "./DeactivateRestaurant.vue?vue&type=template&id=43d3b338&scoped=true"
import script from "./DeactivateRestaurant.vue?vue&type=script&lang=js"
export * from "./DeactivateRestaurant.vue?vue&type=script&lang=js"

import "./DeactivateRestaurant.vue?vue&type=style&index=0&id=43d3b338&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d3b338"]])

export default __exports__